export default "__VITE_ASSET__Dh6yagvH__"